import React, { useEffect, useContext, useState, useRef } from "react";
import { FilesContext } from "../contextProvider";
import { TranscriptionWebSocketContext } from "../transcriptionWssProvider"
import { FilesToJSON, formatDateToGreek, transcribeFile, getRecentFiles } from "./functions";
import { useNavigate } from "react-router-dom";
import { ActionBar, DeleteElement, RetranscribeElement } from "./components";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { BACKEND_URL, BASEPATH } from "../global";
import { enqueueSnackbar } from "notistack";
import Layout from "../components/Layout";
import keycloak from '../keycloak';
import Select from 'react-select';
import JustrediLoader from "../components/justrediLoader";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableClickableHead,
    TableHeader,
    TableRow,
    Label
} from "../shadcnComponents/ui"
import { paginationMenuStyling, paginationMenuTheme, groupsMenuStyling, groupsMenuTheme } from "./reactSelectStyling";

export function RecentFiles() {
    const navigator = useNavigate();
    const [filenamesToDelete, setFileNamesToDelete] = useState([])
    const [fileToRetranscribe, setFileToRetranscribe] = useState({ name: '', id: '' })
    // Filename elements, used to ensure same width equal to max content width of wider filename 
    const nameRefs = useRef([]);
    const [maxWidth, setMaxWidth] = useState("auto");
    // Array of selected filenames
    const [selectedFileNames, setSelectedFileNames] = useState([])
    // Array of selected files and folders ids
    const selectedElements = useRef([])
    //Files as they are fetched from the server
    const context = useContext(FilesContext);
    // const userFromContext = useContext(UserContext);
    const user = JSON.parse(localStorage.getItem('user'))
    const [groupManager, setGroupManager] = useState(false)
    // message state from ws
    const socketMessages = useContext(TranscriptionWebSocketContext)
    // Files after edited with filesToJson function, includes also directory elements
    const [parsedRecentFiles, setParsedRecentFiles] = useState(null)
    // Current directory elements
    const [currentDirectoryFiles, setCurrentDirectoryFiles] = useState([{ id: '', name: '' }])
    // dropdown menu for group allocation
    const [menu, setMenu] = useState([])
    // Groups per file
    const [fileGroups, setFileGroups] = useState(null)
    // Loading page
    const [loading, setloading] = useState(true)

    useEffect(() => {
        if (!keycloak.authenticated) {
            navigator('/login')
        } else {
            // Fetch files
            fetchData(5)
            document.addEventListener("mousedown", handleClickAnywhere);
            return () => {
                document.removeEventListener("mousedown", handleClickAnywhere);
            };
        }
    }, []);

    useEffect(() => {
        if (user && user.resource_access) {
            Object.values(user.resource_access).map(each => { if (each.roles[0] == 'Group Manager') { setGroupManager(true) } })
        }
    }, [user])

    function fetchData(numberOfVisibleFiles) {
        // Fetches groups first to avoid race condition and demonstrate groups per file on first loading of the page

        fetch(BACKEND_URL + "/groups", {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${keycloak.token}`
            }
        }).then((r) => r.json())
            .then((re) => {
                if (re != null) {
                    let menuItems = Array.from(re, (group) => { return { label: group.name, value: group.id } })
                    setMenu(menuItems)
                }
                fetch(`${BACKEND_URL}/asr_results/`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${keycloak.token}`
                    }
                })
                    .then((res) => res.json(), (err) => { console.error(err); setloading(false) })
                    .then((fetchedFiles) => {
                        setloading(false)
                        let fileSystem = FilesToJSON(fetchedFiles);
                        setParsedRecentFiles(getRecentFiles(fileSystem.fileMap, numberOfVisibleFiles))
                        context.resetFileMap(fileSystem, false)
                    })
            }, err => { setloading(false) })
    }

    // Handle click outside files-table && action-bar
    function handleClickAnywhere(event) {
        const filesTable = document.getElementById("files-table");
        const actionBar = document.getElementById('action-bar')
        const deleteMenu = document.getElementById('delete-file')
        if (filesTable != event.target && !filesTable.contains(event.target) &&
            actionBar != event.target && !actionBar.contains(event.target) &&
            deleteMenu != event.target && !deleteMenu.contains(event.target)
        ) {
            unselectAllElements()
        }
    }

    useEffect(() => {
        window.history.pushState({}, '', BASEPATH + '/home');
        if (parsedRecentFiles != null) {
            let groupsPerFile = {}
            parsedRecentFiles.map((value, key) => {
                let tempfileGroups = []
                if (value.groups) {
                    value.groups.map(groupId => {
                        let element = menu.find(el => el.value == groupId)
                        if (element) { tempfileGroups.push(element) }
                    })
                }
                groupsPerFile[key] = tempfileGroups
            })
            setFileGroups(groupsPerFile)
            setCurrentDirectoryFiles(parsedRecentFiles)
        }
    }, [parsedRecentFiles, menu]);

    // Set width of filename column to max content width for all rows of files browser
    useEffect(() => {
        if (nameRefs.current.length > 0) {
            let widths = []
            nameRefs.current.map(ref => { if (ref && typeof ref.offsetWidth === "number") { widths.push(ref.offsetWidth) } });
            setMaxWidth(Math.max(...widths) + "px");
        }
    }, [currentDirectoryFiles]);

    function unselectAllElements() {
        selectedElements.current.map(each => {
            if (document.getElementById(each)) {
                document.getElementById(each).classList.remove('bg-accent')
                document.getElementById(each).classList.remove('selected')
            }
        })
        selectedElements.current = []
        setSelectedFileNames([])
    }

    // Update fileMap with new data
    useEffect(() => {
        if (parsedRecentFiles && socketMessages.messageState.type == 'transcription_status') {
            let newFileMap = []
            parsedRecentFiles.map(each => {
                if (each.interview_id == socketMessages.messageState.asr_result_id) {
                    let newEntry = each
                    newEntry.transcriptionStatus = socketMessages.messageState.status
                }
                newFileMap.push(each)
            })
            setParsedRecentFiles(newFileMap)
        }
    }, [socketMessages])

    // Handle click on element
    function handleClick(event, id) {
        // If tick was clicked, perform no action 

        if (!event.target.closest('.check-symbol') && !event.target.closest('.group-management')) {
            // If ctrl is pressed only select-unselect functionality works
            if (event.ctrlKey) {
                // Add element to selected elements or remove if already selected
                let newSelectedElements = [...selectedElements.current]
                // Unselect element
                if (selectedElements.current.includes(id)) {
                    var index = newSelectedElements.indexOf(id);
                    if (index !== -1) {
                        newSelectedElements.splice(index, 1);
                    }
                    document.getElementById(id).classList.remove('bg-accent')
                    document.getElementById(id).classList.remove('selected')
                } else {
                    // Select element
                    newSelectedElements.push(id)
                    document.getElementById(id).classList.add('bg-accent')
                    document.getElementById(id).classList.add('selected')
                }
                selectedElements.current = newSelectedElements
                setSelectedFileNames(newSelectedElements)
            } else {
                if (event.target.classList.contains('filename')) {
                    //Handled from title element
                } else {
                    // Check if single or double click
                    if (event.detail > 1) {
                        unselectAllElements()
                        // Handle doubleclick
                        localStorage.setItem('interviewId', parsedRecentFiles[id].interview_id)
                        let pathname = window.location.pathname
                        let search = window.location.search
                        window.history.pushState({}, '', BASEPATH + '/myFiles');
                        window.history.pushState({}, '', pathname + search);
                        navigator('/editor', { state: { type: 'database', id: parsedRecentFiles[id].interview_id } });
                    } else {
                        // Handle single click
                        // Unselect element
                        if (selectedElements.current.includes(id)) {
                            unselectAllElements()
                        } else {
                            // Select element
                            selectedElements.current.map(each => {
                                document.getElementById(each).classList.remove('bg-accent')
                                document.getElementById(each).classList.remove('selected')
                            })
                            selectedElements.current = [id]
                            setSelectedFileNames([id])
                            document.getElementById(id).classList.add('bg-accent')
                            document.getElementById(id).classList.add('selected')
                        }
                    }
                }
            }
        }
    }

    function clickFileName(file) {
        navigator('/editor', { state: { type: 'database', id: file.interview_id } });
    }

    // Handle click on tick symbol
    function clickTick(id) {
        let newSelectedElements = []
        // Remove from selection
        if (selectedElements.current.includes(id)) {
            newSelectedElements = [...selectedElements.current]
            var index = newSelectedElements.indexOf(id);
            if (index !== -1) {
                newSelectedElements.splice(index, 1);
            }
            document.getElementById(id).classList.remove('bg-accent')
            document.getElementById(id).classList.remove('selected')
        } else {
            // Add to selection
            newSelectedElements = [...selectedElements.current, id]
            document.getElementById(id).classList.add('bg-accent')
            document.getElementById(id).classList.add('selected')
        }
        selectedElements.current = newSelectedElements
        setSelectedFileNames(newSelectedElements)
    }
    // Convert transcription status to readable text
    function returnTranscriptionStatus(status) {
        if (status == 'TRANSCRIBED') {
            return 'Με μεταγραφή'
        } else if (status == 'IN_PROGRESS') {
            return 'Σε επεξεργασία'
        } else {
            return 'Χωρίς μεταγραφή'
        }
    }

    useEffect(() => {
        if (fileToRetranscribe.name != '' && document.getElementById('retranscribe-file').classList.contains('hidden')) {
            document.getElementById('retranscribe-file').classList.remove('hidden')
        } else if (fileToRetranscribe.name == '' && document.getElementById('retranscribe-file') && !document.getElementById('retranscribe-file').classList.contains('hidden')) {
            document.getElementById('retranscribe-file').classList.add('hidden')
        }
    }, [fileToRetranscribe])

    function displayDeleteMenu() {
        let files = parsedRecentFiles.filter(element => selectedElements.current.includes(element.id))
        let filenames = []
        files.map(each => { filenames.push(each.name) })
        console.log(filenames)
        if (filenames.length == 0) {
            enqueueSnackbar('Δεν έχει επιλεγεί κάποιο αρχείο για διαγραφή', { variant: 'warning', autoHideDuration: 3000 })
        } else {
            setFileNamesToDelete(filenames)
            document.getElementById('delete-file').classList.remove('hidden')
        }
    }

    async function deleteSelectedElements() {
        let filesToDelete = []
        let filesRemaining = []
        parsedRecentFiles.map(each => {
            if (filenamesToDelete.includes(each.name)) {
                filesToDelete.push(each)
            } else {
                filesRemaining.push(each)
            }
        })
        filesToDelete.map(each => {
            fetch(BACKEND_URL + '/asr_results/' + each.interview_id,
                {
                    method: 'DELETE',
                    headers: {
                        Authorization: `Bearer ${keycloak.token}`
                    }
                });
        })
        unselectAllElements()
        setFileNamesToDelete([])
        document.getElementById('delete-file').classList.add('hidden')
        setParsedRecentFiles(filesRemaining)
    }

    function handleTranscriptionRequest() {
        if (selectedElements.current.length == 0) {
            enqueueSnackbar('Δεν έχει επιλεγεί κανένα αρχείο για μεταγραφή', { variant: 'warning', autoHideDuration: 3000 })
        } else if (selectedElements.current.length > 1) {
            enqueueSnackbar('Παρακαλώ επιλέξτε μόνο ένα αρχείο για μεταγραφή', { variant: 'warning', autoHideDuration: 3000 })
        } else {
            let fileToTranscribe = parsedRecentFiles.filter(each => each.id == selectedElements.current[0])
            console.log(selectedElements.current, parsedRecentFiles)
            if (fileToTranscribe[0].transcribed) {
                setFileToRetranscribe({ name: fileToTranscribe[0].name, id: fileToTranscribe[0].interview_id })
            } else {
                transcribeFile(fileToTranscribe[0].interview_id)
            }
        }
    }

    async function changeGroup(newGroups, id) {
        try {
            let data = { groups: Array.from(newGroups, group => group.value) }
            let fileId = parsedRecentFiles[id].interview_id
            let groups = await fetch(`${BACKEND_URL}/asr_results/${fileId}`, {
                method: 'PATCH',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${keycloak.token}`
                },
            })
            let parsedGroups = await groups.json()
            let groupsPerFile = fileGroups
            let tempfileGroups = []
            parsedGroups.groups.map(groupId => {
                let element = menu.find(el => el.value == groupId)
                if (element) {
                    tempfileGroups.push(element)
                }
            })
            groupsPerFile[id] = tempfileGroups
            setFileGroups(groupsPerFile)
        } catch { e => e }
    }

    return (
        <Layout authenticated={true} sidebar={true}>
            {loading && <JustrediLoader />}
            <div className="w-full flex flex-col pl-2 pr-6 grow overflow-x-auto">
                <div className="h-9 mt-8"></div>
                <ActionBar
                    transcribeFile={() => { handleTranscriptionRequest() }}
                    revealDeleteElementMenu={() => { displayDeleteMenu() }} />
                <div id='files-browser' className="w-full h-fit mt-5">
                    <Table id="files-table">
                        <TableHeader>
                            <TableRow className="text-left cursor-default">
                                <TableHead className="w-[30px] pl-[10px]"></TableHead>
                                <TableHead className="w-[calc(25%-20px)]">Όνομα Αρχείου</TableHead>
                                <TableHead className="w-[calc(25%-40px)]">Ημερομηνία επεξεργασίας</TableHead>
                                <TableHead className="w-2/12">Κατάσταση</TableHead>
                                <TableHead className="w-4/12 pr-[20px]">Ομάδες</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {currentDirectoryFiles.length > 0 && currentDirectoryFiles.map((each, index) => {
                                if (each && !each.name.startsWith('dummy')) {
                                    return (
                                        <TableRow className='selectable-element group' onClick={(e) => { e.preventDefault(); handleClick(e, each.id) }} key={each.id} id={each.id}>
                                            <TableCell className="w-[20px] pl-[30px]">
                                                <CheckCircleIcon id={`check-${each.id}`} height={25} className={`${document.getElementById(each.id) && document.getElementById(each.id).classList.contains('selected') ? 'visible' : 'invisible'} check-symbol hover:visible group-hover:visible m-auto text-ring`} onClick={(e) => { e.preventDefault(); clickTick(each.id) }} />
                                            </TableCell>
                                            <TableCell className="w-[calc(25%-20px)]">
                                                <div ref={el => nameRefs.current[index] = el} style={{ minWidth: maxWidth }} className="flex flex-row items-center gap-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" height={24} viewBox="0 0 384 512" className="text-accent-foreground">
                                                        <path fill="currentColor" fillOpacity="0.8" strokeLinejoin="round" strokeLinecap="round" d="M64 48l112 0 0 88c0 39.8 32.2 72 72 72l88 0 0 240c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zM224 67.9l92.1 92.1-68.1 0c-13.3 0-24-10.7-24-24l0-68.1zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-261.5c0-17-6.7-33.3-18.7-45.3L242.7 18.7C230.7 6.7 214.5 0 197.5 0L64 0zM221.9 267.6c-4.7 10-.3 21.9 9.7 26.6 19.2 8.9 32.4 28.3 32.4 50.8s-13.2 41.9-32.4 50.8c-10 4.7-14.4 16.6-9.7 26.6s16.6 14.4 26.6 9.7C281.2 416.8 304 383.6 304 345s-22.8-71.9-55.6-87.1c-10-4.7-21.9-.3-26.6 9.7zM104 305c-13.3 0-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24l16 0 27.2 34c3 3.8 7.6 6 12.5 6l.3 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-.3 0c-4.9 0-9.5 2.2-12.5 6l-27.2 34-16 0zM223.3 373c9.9-5.4 16.7-16 16.7-28.1s-6.7-22.7-16.7-28.1c-7.8-4.2-15.3 3.3-15.3 12.1l0 32c0 8.8 7.6 16.3 15.3 12.1z" />
                                                    </svg>
                                                    <span className="filename cursor-pointer hover:underline" onClick={() => { clickFileName(each) }}>{each.name}</span>
                                                </div>
                                            </TableCell>
                                            <TableCell className="w-[calc(25%-20px)]">
                                                {formatDateToGreek(each.modDate)}
                                            </TableCell>
                                            <TableCell className="w-2/12">
                                                {returnTranscriptionStatus(each.transcriptionStatus)}
                                            </TableCell>
                                            <TableCell className="w-4/12 pr-[20px]">
                                                <Select
                                                    className="group-management multiple-dropdown my-auto min-w-[300px] w-full rounded-lg"
                                                    placeholder={'Επιλογή ομάδων'}
                                                    isClearable={false}
                                                    isDisabled={!(groupManager || user != null && each.ownerId == user.sub)}
                                                    isMulti={true}
                                                    isSearchable={true}
                                                    onChange={(e) => { changeGroup(e, index) }}
                                                    options={menu}
                                                    defaultValue={fileGroups != null && fileGroups[index] && fileGroups[index].length > 0 ? fileGroups[index] : []}
                                                    theme={groupsMenuTheme}
                                                    styles={groupsMenuStyling}
                                                    components={!(groupManager || user != null && each.ownerId == user.sub) ? { DropdownIndicator: () => null, IndicatorSeparator: () => null } : {}}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            })}
                        </TableBody>
                    </Table>
                    {/* Pagination element */}
                    <div className="w-full flex gap-4 text-sm my-5  pr-[calc(1rem+56px)]">
                        <span className="flex flex-col justify-center ml-auto">Πλήθος πρόσφατων αρχείων</span>
                        <Select className="rounded-lg h-5 my-auto"
                            isDisabled={false}
                            isMulti={false}
                            isSearchable={false}
                            onChange={(e) => { fetchData(e.value) }}
                            options={[{ label: 1, value: 1 }, { label: 2, value: 2 }, { label: 5, value: 5 }, { label: 10, value: 10 }, { label: 15, value: 15 }]}
                            defaultValue={{ label: 5, value: 5 }}
                            theme={paginationMenuTheme}
                            styles={paginationMenuStyling}
                        />
                    </div>
                </div>
                <DeleteElement unsetNamesToDelete={() => { setFileNamesToDelete([]) }} namesToDelete={filenamesToDelete} deleteSelected={() => { deleteSelectedElements() }} />
                <RetranscribeElement transcribeSelected={() => { transcribeFile(fileToRetranscribe.id) }} fileToRetranscribe={fileToRetranscribe} unsetNameToRetranscribe={() => { setFileToRetranscribe({ name: '', id: '' }) }} />
            </div>
        </Layout>
    );
}

export default RecentFiles;
